export const IDS = {

    pnpDocumentGrid: 'pnpDocumentGrid',
    pnpDocumentHistoryGrid: 'pnpDocumentHistoryGrid',
    pnpDocumentAccreditationGrid: 'pnpDocumentAccreditationGrid',
    pnpDocSectionsGrid: 'pnpDocSectionsGrid',
    pnpDocumentEventActionsGrid: 'pnpDocumentEventActionsGrid',

    // settings categories states :
    app_policies_documents_add: 'app.policies.documents.add',
    app_policies_documents_add_details: 'app.policies.documents.add.details',
    app_policies_documents_manage: 'app.policies.documents.manage',
    app_policies_documents_manage_details: 'app.policies.documents.manage.details',
    app_policies_documents_manage_listing: 'app.policies.documents.manage.listing',
    app_policies_documents_manage_history_details: 'app.policies.documents.manage.history.details',
    app_policies_documents_manage_history_listing: 'app.policies.documents.manage.history.listing',
    app_policies_documents_accreditation_add: 'app.policies.documents.accreditation.add',
    app_policies_documents_accreditation_add_details: 'app.policies.documents.accreditation.add.details',
    app_policies_documents_accreditation_manage_listing: 'app.policies.documents.accreditation.manage.listing',
    app_policies_documents_event_actions_manage_listing: 'app.policies.documents.manage.eventActions.listing',
};
